document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector("#filter-results ul, #filter-results [role='list']");
  if (!grid) return;

  // Helpers
  const getMaxPage = (root) => {
    const nums = [];
    root.querySelectorAll("nav[aria-label='Pagination'] a[href*='page=']").forEach(a => {
      const m = a.href.match(/(?:\?|&)page=(\d+)/);
      if (m) nums.push(parseInt(m[1], 10));
    });
    const cur = root.querySelector("nav[aria-label='Pagination'] .pagination__page-current");
    if (cur) {
      const n = parseInt(cur.textContent.trim(), 10);
      if (!Number.isNaN(n)) nums.push(n);
    }
    return nums.length ? Math.max(...nums) : 1;
  };

  const buildUrlWithPage = (baseUrl, pageNum) => {
    const u = new URL(baseUrl, window.location.origin);
    u.searchParams.set("page", String(pageNum));
    return u.toString();
  };

  // Initial state
  const initialPagination = document.querySelector("nav[aria-label='Pagination']");
  let currentPage = (() => {
    const cur = document.querySelector("nav[aria-label='Pagination'] .pagination__page-current");
    if (cur) {
      const n = parseInt(cur.textContent.trim(), 10);
      if (!Number.isNaN(n)) return n;
    }
    const m = location.search.match(/(?:\?|&)page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  })();

  // IMPORTANT: read max BEFORE removing pagination
  let nextPageUrl = null;
  if (initialPagination) {
    const maxInitial = getMaxPage(document); // ← read before remove
    if (currentPage < maxInitial) {
      nextPageUrl = buildUrlWithPage(location.href, currentPage + 1);
    }
    initialPagination.remove();
  }

  // Safety: hide any stray pagination
  const style = document.createElement("style");
  style.textContent = `nav[aria-label="Pagination"]{display:none!important}`;
  document.head.appendChild(style);

  // Sentinel
  const sentinel = document.createElement("div");
  sentinel.id = "infinite-scroll-sentinel";
  sentinel.style.height = "1px";
  grid.parentElement.appendChild(sentinel);

  let loading = false;

  const loadMore = () => {
    if (loading || !nextPageUrl) return;
    loading = true;
    console.log("[InfiniteScroll] Fetching:", nextPageUrl);

    fetch(nextPageUrl, { credentials: "same-origin" })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        // READ max BEFORE removing pagination
        const maxPage = getMaxPage(doc); // ← this was the bug

        // Debug
        console.log(
          "[InfiniteScroll] Found page links:",
          [...doc.querySelectorAll("nav[aria-label='Pagination'] a[href*='page=']")].map(a => a.href)
        );

        // Now safe to remove pagination from fetched chunk
        const innerPagination = doc.querySelector("nav[aria-label='Pagination']");
        if (innerPagination) innerPagination.remove();

        // Append products
        const items = doc.querySelectorAll("#filter-results ul > li, #filter-results [role='list'] > li");
        if (!items.length) {
          console.log("[InfiniteScroll] No more products found.");
          nextPageUrl = null;
          observer.disconnect();
          return;
        }
        items.forEach(li => grid.appendChild(li));

        // Update current page from the URL we just fetched
        const m = nextPageUrl.match(/(?:\?|&)page=(\d+)/);
        if (m) currentPage = parseInt(m[1], 10);

        // Build next URL deterministically
        if (currentPage < maxPage) {
          nextPageUrl = buildUrlWithPage(nextPageUrl, currentPage + 1);
        } else {
          nextPageUrl = null;
        }
        console.log("[InfiniteScroll] Updated nextPageUrl:", nextPageUrl);

        if (!nextPageUrl) {
          console.log("[InfiniteScroll] Reached last page.");
          observer.disconnect();
        }
      })
      .catch(err => console.error("[InfiniteScroll] fetch error:", err))
      .finally(() => { loading = false; });
  };

  const observer = new IntersectionObserver(
    entries => { if (entries.some(e => e.isIntersecting)) loadMore(); },
    { rootMargin: "600px" }
  );
  observer.observe(sentinel);
});
